const React = require('react');
const styled = require('@emotion/styled').default;


const Container = styled('div')`
  text-align: center;
  margin: 0 auto;
`

const ErrorCode = styled('div')`
  font-size: 6rem;
  font-weight: 300;
  color: #333;
  margin-bottom: 16px;
  letter-spacing: -0.02em;

  @media (max-width: 768px) {
    font-size: 4rem;
  }
`;


const Title = styled('h1')`
  font-size: 1.5rem;
  font-weight: 400;
  color: #333;
  margin-bottom: 16px;

  @media (max-width: 768px) {
    font-size: 1.3rem;
  }
`;

const Description = styled('div')`
  color: #666;
  font-size: 1rem;
  margin-bottom: 32px;
  line-height: 1.6;
`;


const ForbiddenPage = () => {
  return (
    <Container>
      <ErrorCode>403</ErrorCode>
      <Title>Access Forbidden</Title>

      <Description>
        Access is denied.
      </Description>

    </Container>
  );
};

module.exports = ForbiddenPage;
